import { HttpParams } from '@angular/common/http'
import { Component, effect, input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { CellEditEndingEventArgs, FlexGrid } from '@grapecity/wijmo.grid'

import { BaseComponent, Grid, NotificationInstance } from '../../../shared'
import { ActionToolbarCount } from '../../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { AutoSizeDirective } from '../../../shared/utility/auto-size.directive'

@Component({
    selector: 'app-foreman-schedule-notifications-tab',
    templateUrl: './foreman-schedule-notifications-tab.component.html',
    standalone: true,
    imports: [FormsModule, ActionToolbarCount, ActionToolbarSearchComponent, WjGridModule, AutoSizeDirective, WjGridFilterModule],
})
export class ForemanScheduleNotificationsTabComponent extends BaseComponent {
    grid: Grid<NotificationInstance>
    usersGrid: Grid<any>
    isActive = input(false)

    constructor() {
        super()
        this.grid = new Grid<NotificationInstance>(this.services)
            .wrapColumnHeaders()
            .filterBy(item => [item.title, item.body, item.category])

        this.usersGrid = new Grid<any>(this.services)
            .wrapColumnHeaders()
            .filterBy(item => [item.displayName])
            .isReadOnly(false)

        effect(() => {
            if (this.isActive()) this.refresh()
        })
    }

    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(true, true, this.services.data.get<NotificationInstance[]>('/api/ForemanSchedule/GetScheduleNotifications'))
                .subscribe({
                    next: result => {
                        this.grid.items = result[0] ?? []
                    },
                }),
        )
    }

    getRecipients() {
        if (!this.grid.selectedItem) return
        const params = new HttpParams().append('instanceId', this.grid.selectedItem.id)
        this.cancelableRequest(
            'recipients',
            true,
            this.services.data
                .load(true, true, this.services.data.get<any[]>('/api/ForemanSchedule/GetScheduleNotificationRecipients', params))
                .subscribe({
                    next: result => {
                        this.usersGrid.items = result[0] ?? []
                    },
                }),
        )
    }

    cellBeginningEdit(_flexGrid: FlexGrid, args: CellEditEndingEventArgs) {
        args.cancel = true
    }
}
